import { useEffect } from 'react';

export const useThemeListener = (onThemeChange) => {
  useEffect(() => {
    const classObserver = new MutationObserver((mutations) => {
      mutations.forEach((mu) => {
        if (mu.type !== 'attributes' && mu.attributeName !== 'class') return;
        onThemeChange();
      });
    });
    const body = document.querySelector('body');
    classObserver.observe(body, { attributes: true });
  }, [onThemeChange]);
};
